export const SERVICE_NOT_FOUND = 410;
export const INVALID_PERMISSIONS = 200;
